(ns app.front.ui.toggle-list
  "A list of on/off settings, each row with a name, an optional description and
  a toggle. Callers pass plain data, so any set of switches fits."
  (:require [app.front.util :refer [for-frag]]
            [core.front.carbon :as cc]
            [potpuri.core :as p]))

(defn toggle-row
  "One setting.

  Props:
  - `:id`          unique string, used for the toggle's DOM id
  - `:label`       setting name, string or hiccup
  - `:description` optional explanation shown under the label
  - `:toggled?`    current state
  - `:disabled?`   when true the toggle cannot be changed
  - `:title`       optional tooltip, e.g. why the toggle is disabled
  - `:on-toggle`   `(fn [toggled?] ...)`"
  [{:keys [id label description toggled? disabled? title on-toggle]}]
  [:div.grid.items-center.gap-4.px-4.py-3.transition-colors.hover:bg-ui-white
   (p/assoc-if {:class   "grid-cols-[1fr_auto]"
                :data-cy (str "toggle-row-" id)}
               :title title)
   [:div.flex.flex-col {:class "gap-0_5"}
    [:span.font-semibold.text-sm {:id (str "toggle-label-" id)} label]
    (when description
      [:span.text-sm.text-gray-600 description])]
   (cc/toggle (p/assoc-if
                {:id              (str "toggle-" id)
                 :toggled         (boolean toggled?)
                 :disabled        (boolean disabled?)
                 ;; The row label is the accessible name, so Carbon's on/off
                 ;; captions go, and `unlabeled-toggle` reclaims their space to
                 ;; centre the switch.
                 :class-name      "unlabeled-toggle"
                 :labelA          ""
                 :labelB          ""
                 :aria-labelledby (str "toggle-label-" id)}
                :on-toggle on-toggle))])

(defn toggle-list
  "Rows of settings on a muted background, each lifting to white on hover;
  `overflow-hidden` clips the hover to the rounded corners.

  Props:
  - `:items` sequence of `toggle-row` prop maps
  - `:class` extra classes for the list element"
  [{:keys [items class]}]
  [:div.bg-gray-100.rounded.overflow-hidden {:class class}
   (for-frag [item items]
     [toggle-row item])])
